import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ServiceType } from '../models/service-type.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceTypeService {

  private apiUrl = `${environment.sgcApi}`;
  private serviceRoute = 'service';

  constructor(
    private httpClient: HttpClient
  ) {}

  getServices(): Observable<ServiceType[]> {
    return this.httpClient.get<ServiceType[]>(`${this.apiUrl}${this.serviceRoute}/map`)
      .pipe(map((data) => data));
  }

  getServiceMapByExerciseAndSchool(exerciseId: number, schoolId: number): Observable<ServiceType[]> {
    const url = `${this.apiUrl}${this.serviceRoute}/exercise/${exerciseId}/schoolId/${schoolId}`;
    return this.httpClient.get<ServiceType[]>(url)
      .pipe(map((data) => data));
  }
}
